<div #grid>
  <div *ngIf="tags" class="seb-container">
    <div [style.color]="item.colorB" [style.backgroundColor]="item.colorA" *ngFor="let item of tags"
      class="seb-container-tag">
      {{ item.name }}
    </div>
    <div class="countItems" *ngIf="pointer">
      +{{ heightAllObjs }}
    </div>

  </div>

  <div *ngIf="products" class="seb-container">
    <div [style.color]="'#fff'" [style.backgroundColor]="'#51BEAE'" *ngFor="let item of products"
      class="seb-container-tag">
      {{ item }}
    </div>
    <div class="seb-container-leg" *ngIf="pointer">
      <i style="font-size: 20px" class="material-icons">
        add
      </i>
      {{ heightAllObjs }}
    </div>

  </div>
</div>
